import React from 'react';
import PageWrapper from '../components/PageWrapper';

const Home = ({ onNavigate }) => (
  <PageWrapper onNavigate={onNavigate} showFullFooter>
    {/* HERO */}
    <section style={{
      minHeight: '88vh',
      background: 'linear-gradient(135deg, #071a12 0%, #0d3d2a 55%, #1a5c3e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
      padding: '4rem 2rem',
    }}>
      {/* Decorative gold line */}
      <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', background: 'linear-gradient(to bottom, transparent, #c9a84c, transparent)' }} />
      <div style={{ textAlign: 'center', zIndex: 1, maxWidth: '780px' }}>
        <div style={{ border: '1px solid #c9a84c', color: '#c9a84c', fontSize: '.62rem', letterSpacing: '3px', textTransform: 'uppercase', padding: '.45rem 1.3rem', display: 'inline-block', marginBottom: '1.5rem' }}>
          Global Trusted Consulting Partner
        </div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", color: '#fff', fontSize: 'clamp(2.5rem, 6vw, 5rem)', lineHeight: 1.1, marginBottom: '1rem' }}>
          Unlocking Africa's<br /><span style={{ color: '#c9a84c' }}>Resource Potential</span>
        </h1>
        <p style={{ color: '#a8c4b4', fontSize: '1rem', maxWidth: '520px', margin: '0 auto 2.5rem', fontWeight: 300, lineHeight: 1.85 }}>
          Varahi Global Consulting bridges global expertise with African opportunity — across mining, diamonds, renewable energy, and eco-tourism.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
          {['⛏ Mining', '◆ Diamonds', '♻ Renewables', '🌿 Eco Tourism'].map(t => (
            <span key={t} style={{ background: 'rgba(201,168,76,.12)', border: '1px solid rgba(201,168,76,.3)', color: '#e8c96a', padding: '.4rem 1rem', fontSize: '.78rem', letterSpacing: '1px' }}>{t}</span>
          ))}
        </div>
        <button className="btn-gold" onClick={() => onNavigate('services')}>Explore Services</button>
        <button className="btn-outline" style={{ marginLeft: '1rem' }} onClick={() => onNavigate('contact')}>Get In Touch</button>
      </div>
    </section>

    {/* STATS */}
    <section className="section" style={{ background: '#071a12', padding: '4rem 3rem' }}>
      <div className="stats-row">
        <div className="stat-box"><span className="stat-num">25+</span><span className="stat-label">Years Experience</span></div>
        <div className="stat-box"><span className="stat-num">18</span><span className="stat-label">African Countries</span></div>
        <div className="stat-box"><span className="stat-num">120+</span><span className="stat-label">Projects Delivered</span></div>
        <div className="stat-box"><span className="stat-num">$2B+</span><span className="stat-label">Value Facilitated</span></div>
      </div>
    </section>

    {/* WHAT WE DO */}
    <section className="section" style={{ background: '#f9f7f3' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <p className="section-label">Our Sectors</p>
        <h2 className="section-title" style={{ textAlign: 'center' }}>Comprehensive African Expertise</h2>
        <div className="gold-line center" />
        <p className="section-sub center" style={{ marginBottom: '3rem' }}>From mineral exploration to conservation tourism — Varahi delivers end-to-end consulting solutions across Africa's most dynamic sectors.</p>
        <div className="grid-4">
          {[
            { icon: '⛏', title: 'Mining', desc: 'End-to-end consultancy for mineral exploration, extraction, and compliance across Africa.', page: 'mining' },
            { icon: '◆', title: 'Diamonds', desc: 'Ethical diamond sourcing, certification, and trade facilitation with global markets.', page: 'diamonds' },
            { icon: '♻', title: 'Renewables', desc: 'Solar, wind, and hydro energy project development driving Africa\'s green future.', page: 'renewables' },
            { icon: '🌿', title: 'Eco Tourism', desc: 'Conservation-led tourism ventures that generate sustainable livelihoods.', page: 'ecotourism' },
          ].map(c => (
            <div key={c.title} className="card card-gold-top" style={{ cursor: 'pointer' }} onClick={() => onNavigate(c.page)}>
              <span className="card-icon">{c.icon}</span>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* WHY VARAHI */}
    <section className="section" style={{ background: '#071a12' }}>
      <div className="container">
        <div className="grid-2" style={{ alignItems: 'center', gap: '4rem' }}>
          <div>
            <p className="section-label">Why Choose Us</p>
            <h2 className="section-title white">Decades of African Expertise</h2>
            <div className="gold-line" />
            <p className="section-sub white" style={{ marginBottom: '2rem' }}>With deep roots across sub-Saharan Africa, we connect investors, governments, and communities to sustainable, high-impact opportunities.</p>
            {['On-ground presence in 18 African nations', 'Deep regulatory and cultural expertise', 'Proven track record across all four sectors', 'Ethical, transparent, long-term approach'].map(item => (
              <div key={item} style={{ display: 'flex', gap: '.75rem', alignItems: 'flex-start', marginBottom: '.85rem' }}>
                <span style={{ color: '#c9a84c', fontSize: '1rem', marginTop: '.1rem' }}>✓</span>
                <span style={{ color: '#a8c4b4', fontSize: '.9rem' }}>{item}</span>
              </div>
            ))}
            <button className="btn-gold" style={{ marginTop: '1.5rem' }} onClick={() => onNavigate('about')}>About Us</button>
          </div>
          <div className="grid-2" style={{ gap: '1rem' }}>
            {[
              { icon: '🌍', title: 'West Africa', desc: 'Ghana, Nigeria, Sierra Leone, Guinea' },
              { icon: '🌍', title: 'East Africa', desc: 'Kenya, Tanzania, Uganda, Mozambique' },
              { icon: '🌍', title: 'Southern Africa', desc: 'Botswana, Zimbabwe, Zambia, Angola' },
              { icon: '🏢', title: 'India HQ', desc: 'Hyderabad, Telangana' },
            ].map(c => (
              <div key={c.title} className="card-dark">
                <span style={{ fontSize: '1.5rem', display: 'block', marginBottom: '.6rem' }}>{c.icon}</span>
                <h3 style={{ fontSize: '1rem', marginBottom: '.3rem', color: '#c9a84c', fontFamily: "'Playfair Display', serif" }}>{c.title}</h3>
                <p style={{ fontSize: '.82rem', color: '#a8c4b4' }}>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* TESTIMONIALS */}
    <section className="section">
      <div className="container" style={{ textAlign: 'center' }}>
        <p className="section-label">Testimonials</p>
        <h2 className="section-title" style={{ textAlign: 'center' }}>What Our Partners Say</h2>
        <div className="gold-line center" />
        <div className="grid-3" style={{ marginTop: '2rem' }}>
          {[
            { quote: "Varahi's ground-level knowledge of African markets is unmatched. They guided our solar investment flawlessly.", author: 'CEO, European Energy Fund' },
            { quote: "The diamond sourcing network Varahi provided opened markets we couldn't access alone. Exceptional team.", author: 'Director, GEM Trading Co.' },
            { quote: "From regulatory navigation to community engagement, Varahi delivered beyond our expectations every time.", author: 'VP, Mining Corp International' },
          ].map((t, i) => (
            <div key={i} className="card" style={{ textAlign: 'left' }}>
              <span style={{ fontSize: '2rem', color: '#c9a84c', display: 'block', marginBottom: '.75rem' }}>"</span>
              <p style={{ fontStyle: 'italic', lineHeight: 1.85, marginBottom: '1rem' }}>{t.quote}</p>
              <p style={{ fontSize: '.78rem', color: '#c9a84c', fontWeight: 700, letterSpacing: '1px' }}>— {t.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="section" style={{ background: '#0d3d2a', textAlign: 'center' }}>
      <div className="container">
        <h2 className="section-title white" style={{ textAlign: 'center' }}>Ready to Enter Africa?</h2>
        <div className="gold-line center" />
        <p className="section-sub white center" style={{ marginBottom: '2rem' }}>Let Varahi Global Consulting be your strategic gateway. Contact us for a confidential consultation.</p>
        <button className="btn-gold" onClick={() => onNavigate('contact')}>Start a Conversation</button>
      </div>
    </section>
  </PageWrapper>
);

export default Home;
